import { useEffect, useMemo, useState } from "react";
import AddMember from "./addMember";
import GuestModal from "./guestModal";
import Slot from "./slot";
import swal from 'sweetalert2';
import { bookTeeTime, updateTeeTime, releasePendingTeeTime, deleteTeeTimeBook, getUserDetailsByID, getTeeTimeBook, updateSlot } from "../api/teeTimeAPI";
import { getAuthState } from "../../assets/scripts/login-util";
import AddGSTNumber from "./addGSTNumber";
import FeeSummary from "./feeSummary";
import { calculateGreenFee } from "./useGreenFeeCalculator";



const BookingModal = (props) => {//bookingMembers,teeTimeData,greenFeeMaster,SelectedDate,onDismissModal

  let timerInterval;
  const { user } = getAuthState();
    const [timer,        setTimer]        = useState('3:00');    
    const [addModal,            setAddModal]        = useState(false);
    const [addSlot,            setAddSlot]          = useState(false);
    const [slot, setSlot] = useState({
        Slot: props?.teeTimeData?.Slot,
        TemplateID: props?.teeTimeData?.TemplateID,
      });
    const [newSlot, setNewSlot] = useState({
        Slot: props?.teeTimeData?.Slot,
        TemplateID: props?.teeTimeData?.TemplateID,
    });
    const [members,             setMembers]         = useState([]);//use for getting selected member from member modal
    const [userList,            setUserList]         = useState([]);//use for getting selected member from member modal
    const [comment,             setComment]         = useState(props?.teeTimeData?.Comment ?? '');
    const [hole, setHole] = useState(props?.teeTimeData?.Hole);
    const [addGuest,            setAddGuest]        = useState(false);
    const [showGSTModal,        setShowGSTModal]    = useState(false);
    const [selectedCompany,     setSelectedCompany] = useState(null);
    const [refID, setRefID] = useState(null);
    const [greenFeeList,      setGreenFeeList]  = useState(props.greenFeeMaster || []);
    const [greenFeeMasterList,      setGreenFeeMasterList]  = useState(props.greenFeeMaster || []);
    const [rateDetails, setRateDetails] = useState({});
    const [paymentMethod, setPaymentMethod] = useState("0"); 
    const [cartAvailability, setCartAvailability] = useState(props.cartAvailability || 0); 
    const [totalMembersCount, setTotalMembersCount] = useState(props?.bookingMembers?.length + props?.bookingOtherMembers?.length); 
    const [refresh,             setRefresh]             = useState(false);
    const day = useMemo(() => moment(props.SelectedDate, 'YYYY-MM-DD').day(), [props.SelectedDate]);

    const isWeekend = useMemo(() => {
        return (day === 6 || day === 0 || (props.Holiday !== null && props.Holiday !== undefined)) ? "Y" : "N";
    }, [day, props.Holiday]);
  
    useEffect(()=> { 
        if(props.SelectedDate) fetchTeeTimeBook(props.SelectedDate) 
    }, [props.SelectedDate, refresh]);   
    const refetchTeeTime = ()=> setRefresh((r) => !r);
  

  // useEffect(() => {
  //   if (props.bookingMembers) {
  //     const updated = calculateGreenFee(props.bookingMembers);
  //     setUserList(updated);
  //     setMembers(updated);
  //   }
  // }, [props.bookingMembers]);

  // useEffect(() => {
  //   if (props.action == 'e') {
  //     fetchTeeTimeBook(props.SelectedDate)
  //   }
  //   if (props.bookingMembers && props.bookingMembers.length) {
  //     const updated = calculateGreenFee(props.bookingMembers);
  //     setMembers(updated);
  //     setUserList(updated);
  //   }
  // }, [props.teeTimeData, props.greenFeeMaster, props.bookingMembers]);
  
  useEffect(() => {
    if (Array.isArray(props.bookingMembers) && props.bookingMembers.length === 0) return; 
    setTotalMembersCount(props?.bookingMembers?.length + props?.bookingOtherMembers?.length)
    // if (props.action === 'e') {
      const loadData = async () => {
        const res = await fetchTeeTimeBook(props.SelectedDate);
        // const updated = calculateGreenFee(props.bookingMembers, hole, props.SelectedDate, props.Holiday, res.GreenFeeMaster, setGreenFeeList, setRateDetails);
        // setMembers(updated);
        // setUserList(updated);
      };
      // UserList,SelectedDate,Holiday,greenFeeMasterList,setGreenFeeList,setRateDetails
      loadData();
    // }

    // const updated = calculateGreenFee(userList,hole,props.SelectedDate,props.Holiday,greenFeeMasterList,setGreenFeeList,setRateDetails);
    // setUserList(updated)
    
  }, [props.bookingMembers,props.bookingOtherMembers]);

  useEffect(() => {
      if (props.action === "a") {
        bookTimer();
        getUserDetails();
      }
      // loadData(); // invoke the async function
      $('#modalBook').modal({ backdrop: 'static', keyboard: false });
      $('#modalBook').on('hidden.bs.modal', function () {
      $('.modal').hasClass('show') && $('body').addClass('modal-open');
      props.onDismissModal(false);
      });
    
    // if (props.action == "e") calculateGreenFee(userList);
    
      return () => clearInterval(timerInterval); 
    }, []);
  

  const fetchTeeTimeBook = async (params) => {
      try {
          let dateToFetch = params; 
                                              
          /**@listens - selectedDate < serverDate -> sends serverDate || selected Date */
          // if((pageData?.ServerDate) && moment(dateToFetch).isBefore(pageData.ServerDate))
          //     dateToFetch = pageData?.ServerDate;
                      
        const response = await getTeeTimeBook(moment(dateToFetch).format('YYYY-MM-DD'));
        setGreenFeeMasterList(response.GreenFeeMaster)
        setCartAvailability(response.CartStatus?.Available);
        // const updated = calculateGreenFee(props.bookingMembers,hole,props.SelectedDate,props.Holiday,response.GreenFeeMaster,setGreenFeeList,setRateDetails);
        
        // calculateGreenFee(userList)
        return response;
          
      } catch (err) {
          swal.fire({icno: "error",titleText: "Error!",text: err.message});
          return;  
      }
  }
  
  // side effects

  useEffect(() => {
    const updated = calculateGreenFee(userList,hole,props.SelectedDate,props.Holiday,greenFeeMasterList,setGreenFeeList,setRateDetails);
    setUserList(updated)
      // calculateGreenFee(userList)
    }, [hole])
  
    
    useEffect(() => {
      if (addModal) $('#modalBook').addClass('modal-blur');    
    }, [addModal]);
 
    const bookTimer =()=> {
      // let t = 179; // 3 minutes in seconds
      let t = 60*3; // 3 minutes in seconds

      timerInterval = setInterval(()=>{
          if(t > 0){
              const d  = (t % (60 * 60));
              const ds = Math.ceil(d % 60);
              const ms = { m: Math.floor(d / 60), s: ds < 10 ? (`0${ds}`): ds };
              t = t - 1;
              setTimer(`${ms.m}:${ms.s}`);                
          }else{
              t = 0;
              if (timerInterval) clearInterval(timerInterval);
              setTimer('Time Expired');
              swal.close();
              $('#modalBook').modal('hide');
                return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: 'Booking Time Expired..!'});
          }
      }, 1000);
  }
  
    const getUserDetails = async () => {
    const { user } = getAuthState();
      const { User } = await getUserDetailsByID(user.id);
    
    if (User) {
        const isSubscriptionExpired = moment(User.SubscriptionExpiresOn).isBefore(moment(props.SelectedDate));
        const isMembershipExpired = moment(User.MembershipExpiresOn).isBefore(moment(props.SelectedDate));
        const isHolidayCondition = User.SubCategoryID === 7 && isWeekend === "Y";
        const isValidMember = (isSubscriptionExpired || isMembershipExpired || isHolidayCondition) ? 'N' : 'Y';
        const initialMember = [{
            UserID: User.ID,
            UserName: User.UserName ||
            `${User?.FirstName || ""} ${User?.MiddleName || ""} ${
              User?.LastName || ""
            }`.trim() ||
            "Unknown User",
            UserType: 'User',
            CategoryID: User.CategoryID || 1,
            SubCategoryID: User.SubCategoryID || 1,
            IsValidMember: isValidMember,
            IsCartRequired: "Y",
            IsCaddyRequired: "Y",
            IsDisabled: true,
            IsChecked: true,
            IsCartUpdated: false,
            MembershipNo: User.MembershipNo || "M001"
        }];
      // const updatedMember = calculateGreenFee(initialMember, hole);
      const updatedMember = calculateGreenFee(initialMember,hole,props.SelectedDate,props.Holiday,greenFeeMasterList,setGreenFeeList,setRateDetails);
      
        setMembers(updatedMember);
        setUserList(updatedMember);
      }
    }
  
    const updateMembersAndCalculate = (newMembers) => {
      newMembers = calculateGreenFee(newMembers,hole,props.SelectedDate,props.Holiday,greenFeeMasterList,setGreenFeeList,setRateDetails);
        setMembers(newMembers);
        setUserList(newMembers);
      };

    const userUpdateCart = (rowIndex, isChecked) => {

      let users = [...userList];
      users = users.map((user, i) => {
          if (i === rowIndex) {
            if (isChecked) {
              return {
                ...user,
                IsCartRequired: "Y",
                IsCaddyRequired: "Y",
                IsChecked: isChecked,
                IsCartUpdated: true,
              };
            } else {
              return {
                ...user,
                IsCartRequired: "N",
                IsCaddyRequired: "N",
                IsChecked: isChecked,
                IsCartUpdated: false,
              };
            }
          }
        return user;
      });
      
    
      // const m  = calculateGreenFee(users);
      const m = calculateGreenFee(users,hole,props.SelectedDate,props.Holiday,greenFeeMasterList,setGreenFeeList,setRateDetails);

      setMembers(m)
      setUserList(m)
    };

  const handleHoleChange = ({ target }) => {
      setHole(parseInt(target.value));
    };

    const handleComment = (c) => setComment(c);

    const handlePaymentMethodChange = (e) => {
      setPaymentMethod(e.target.value);
    };
  


    const handleShowGSTModal = () => {
        setShowGSTModal(true);
        if (members.length > 0) {
            setRefID(members[0].UserID);
        }
    };
  
    const addMemberHandler = (type) => {
      if((members.length + props?.bookingMembers?.length) > 3){
          swal.fire({ icon: 'warning', buttonsStyling: false, text: 'Maximum 4 users are allowed'});            
          return;
      } else  {
          // if(type === "guest")
          //   setAddGuest(true);
          // else if (type === "slot") {
          //   setAddSlot(true);
          // }
          // else
        //   setAddModal(true);
        setAddSlot(true);
      }
  };

    const releaseTeeSlot = async()=> {
      try {      
          await releasePendingTeeTime(props.teeTimeData.ID); // release api 
      } catch (err) {
          swal.fire({ icon: "error",titleText: "Error!",text: err.message });
          return;
      }
    }


    const onBookingModalClose = () => {
        if(props.action !== "a") return $('#modalBook').modal('hide');        

        swal.fire({
            icon: 'warning',
            titleText: 'Are you sure, you want to close, your teetime will be released?',           
            showCancelButton: true,
            confirmButtonText: 'Yes',           
            cancelButtonText:'No'
        }).then(async(result) => {
            if (result.isConfirmed) {
              $('#modalBook').modal('hide');   
              releaseTeeSlot();
            } 
        });
    };

  const cancelBooking = async () => {    
        swal.fire({
            icon: 'warning',
            titleText: 'Are you sure, you want to cancel?',           
            showCancelButton: true,
            confirmButtonText: 'Yes',           
            cancelButtonText:'No'
        }).then(async(result) => {
            
          if (result.isConfirmed) {
                try {
                  const book = props.teeTimeData;        
                    swal.fire({
                        titleText: 'Loading',
                        text: 'Please Wait...',
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        onOpen: () => {
                            swal.showLoading();
                        }
                    });

                    const res = await deleteTeeTimeBook(book.ID, comment);

                    if (res) {
                      props.updateBookingList(prevList => prevList.filter(booking => booking.ID !== book.ID));
                    }
            
                    swal.close();
                    $('#modalBook').modal('hide');
                    swal.fire({ 
                        icon: 'success', 
                        timer: 1500, 
                        showConfirmButton: false,
                        titleText: 'TeeTime Cancelled Successfully',
                    });

                    props.refetchTeeTime();                                
                } catch (err) {
                    swal.close();
                    swal.fire({ icon: "error", titleText: "Error!", text: err.message });
                    return;
                }                                    
            } 
        });
  };
  
  const viewForm = (transactionID) => {
    let baseURL = 'https://dev-ogr.golfez.in/invoice?id=';
        window.open(`${baseURL}${transactionID}`, '_blank', 'noopener');
    };

    const postBooking = async() => { 
      try {
        if (timer == "Time Expired" && props.action == 'a') {
          swal.close();
          $('#modalBook').modal('hide');
            return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: 'Booking Time Expired..!'});
        }

        const book = props.teeTimeData;
        book.CompanyID = selectedCompany?.ID || '';
        book.PaymentMethod = paymentMethod;
        book.Comment = comment;
            
        if (props.bookingMembers?.length === 0) {
          book.Hole = hole;
        }

        
        const users = userList.map(m => ({ ...m, TeeTimeBookID: book.ID }));  
        if (users.length === 0) return;
            
            swal.fire({
              titleText: 'Loading',
              text: 'Please Wait...',
              showConfirmButton: false,
              allowOutsideClick: false,
              onOpen: () => {
                swal.showLoading();
              }
            });
            if (props.action === 'e') {   
                await updateTeeTime(users);              
            } else {
              // await bookTeeTime(users, book.Comment, rateDetails);
                await bookTeeTime(users, book, rateDetails, props.bookingMembers);
            }
                  
            swal.close();
            $('#modalBook').modal('hide');
            swal.fire({ 
                icon: 'success', 
                timer: 1500, 
                showConfirmButton: false,
                titleText: `TeeTime ${(props.action === 'e') ? 'Updated': 'Confirmed'} Successfully`,
            });
            props.refetchTeeTime();
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;
        }
    };
  
    const updateBooking = async() => { 
      try {
        if (timer == "Time Expired" && props.action == 'e') {
          swal.close();
          $('#modalBook').modal('hide');
            return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: 'Booking Time Expired..!'});
        }

        // if (slot.TemplateID === newSlot.TemplateID) {
        //   swal.close();
        //   $('#modalSlot').modal('hide');
        //   return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: `Can't update the same slot!` });
        // }
        const book = props.teeTimeData;
        // book.CompanyID = selectedCompany?.ID || '';
        book.Comment = comment;
        book.TemplateID = newSlot.TemplateID;
            
          swal.fire({
            titleText: 'Loading',
            text: 'Please Wait...',
            showConfirmButton: false,
            allowOutsideClick: false,
            onOpen: () => {
              swal.showLoading();
            }
          });
          if (props.action === 'e') {   
              await updateSlot(book);              
          }
                  
          swal.close();
          $('#modalBook').modal('hide');
          swal.fire({ 
              icon: 'success', 
              timer: 1500, 
              showConfirmButton: false,
              titleText: `TeeTime ${(props.action === 'e') ? 'Updated': 'Confirmed'} Successfully`,
          });
        //refetchTeeTime();
        
          props.refetchTeeTime();
        
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;
        }
    };
  
  const onBookSelect = async (book) => {
          try {
            const isAfter = moment(serverTime, 'DD-MM-YYYY hh:mm:ss A').isAfter(
              moment(`${moment(props.SelectedDate).format("DD-MM-YYYY")} ${book.Slot}`, 'DD-MM-YYYY hh:mm A')
            );
            if (isAfter) return;
        
            if (book.Status === "Booked" || book.Status === "Pending") return;
            book.BookDate = moment(selectedDate).format("YYYY-MM-DD");
        
          } catch (err) {
              
            swal.close();
        
            if (
              err.message === 'Error: Tee Time already blocked by another member' ||
              err.message === 'Tee Time already blocked by another member'
            ) {
              swal.fire({
                toast: true,
                icon: 'warning',
                titleText: 'Tee Time already blocked by another member',
                position: 'center',
                showConfirmButton: false,
                timer: 2000,
                animation: false,
                customClass: {
                  popup: 'margin-20',
                },
              });
            } else {
              swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            }
          }
        };

    return (
      <>
        <div
          id="modalBook"
          className="modal fade modal-responsive"
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
              <div className="col">
                            <div className="col-xs-5 ">
                                <h4 id="modalBookTitle" className="modal-title">Book</h4>
                            </div>
                  <div className={`col-xs-7 ${window.innerWidth < 720 ? '5' : timer == 'Time Expired' ? '5' : '50'}`} style={{ width: "100%", margin:"0 auto"}}>
                                {(props.action == "a") && ( <h5 id="otpTimer" className="margin-t10 margin-l40" style={{color: 'Red',margin:"0 auto", fontSize: '23px', fontWeight: '500', width: `${timer == 'Time Expired' ? '160px' : '70px'}`, height:' 43px', border: '1px solid rgb(128 128 128 / 12%)', padding: '10px', boxShadow: '#9db2b99c 1px 4px 5px', backgroundColor: 'rgb(128 128 128 / 32%)'}}>{timer}</h5> )}
                            </div>
                        </div>
                {/* <div className="row">
                  <div className="col-xs-5">
                    <h4 id="modalBookTitle" className="modal-title">
                      Book
                    </h4>
                  </div>
                </div> */}
              </div>
              <div className="text-center">
                {props?.teeTimeData?.TrackingID && <h5 className="">Tracking ID : {props?.teeTimeData?.TrackingID}</h5>}
              </div>
              <div className="modal-body padding-t0">
                <div id="ModalHolder1">
                  <div id="bookingForm" role="form">
                    <div className="form-group">
                      <div className="input-group">
                        <span className="input-group-addon">
                          {" "}
                          <i className="fa fa-lock fa-lg"></i>{" "}
                        </span>
                        <input
                          id="lblDate"
                          name="lblDate"
                          className="form-control"
                          type="text"
                          readOnly="readOnly"
                          placeholder="Date"
                          value={moment(props.SelectedDate).format(
                            "DD-MMM-YYYY"
                          )}
                        />
                      </div>
                    </div>

                    <div id="pnlSlot1" className="form-group">
                      <div className="input-group">
                        {(props?.editValidation?.IsEdit && props.teeTimeData?.UserID == user.id && props?.bookingOtherMembers?.length === 0) ? (<>
                          <span className="input-group-addon">
                          {" "}
                          <i className="fa fa-pencil fa-lg" aria-hidden="true"></i>
                        </span>
                        <div onClick={() => setAddSlot(true)}>
                          <input
                            id="lblSlot"
                            name="lblSlot"
                            className="form-control"
                            type="text"
                            readOnly="readOnly"
                            data-id=""
                            placeholder="Slot"
                            value={newSlot.Slot}
                            // onClick={() => addMemberHandler("slot")}
                          />
                        </div>
                        </>) : <>
                        <span className="input-group-addon">
                          {" "}
                          <i id="icSlot1" className="fa fa-lock fa-lg"></i>
                        </span>
                        <input
                          id="lblSlot"
                          name="lblSlot"
                          className="form-control"
                          type="text"
                          readOnly="readOnly"
                          data-id=""
                          placeholder="Slot"
                          value={props.teeTimeData.Slot}
                        />
                        </>}
                      </div>
                    </div>

                    {/* {(props.action === "a" ||
                      props?.editValidation?.IsEdit) && (
                      <>
                        <div
                          id="pnlMember"
                          className="form-group margin-t20 margin-b0"
                        >
                          <div className="row">
                            <div className="col-xs-12">
                              <div className="col-xs-6">
                                <button
                                  id="btnAddMember"
                                  className="btn btn-default btn-block btn-add padding-2"
                                  type="button"
                                  onClick={() => addMemberHandler("member")}
                                >
                                  Add Member
                                </button>
                              </div>
                              <div className="col-xs-6">
                                <button
                                  id="btnAddGuest"
                                  className="btn btn-default btn-block btn-add padding-2"
                                  type="button"
                                  onClick={() => addMemberHandler("guest")}
                                >
                                  Add Guest
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )} */}
                  </div>
                  <div className="row">
                    <div className="col-xs-12">
                      <hr className="divider" />
                    </div>
                  </div>
                  {/* <div className="form-group">
                    <div className="col-sm-10 padding-0 padding-l10 margin-tb10">
                      <label className="inline">
                        <input
                          type="radio"
                          id="redio18"
                          className="redio18"
                          name="hole"
                          value="18"
                          checked={hole === 18}
                          onChange={handleHoleChange}
                        />
                        <span className="lbl">18 Holes</span>
                      </label>
                      {(isWeekend!=='Y') && (
                          <label className="kt-radio kt-radio--brand padding-l10">
                            <input
                              type="radio"
                              id="radio9"
                              className="radio9"
                              name="hole"
                              value="9"
                              checked={hole === 9}
                              onChange={handleHoleChange}
                            />
                            <span className="lbl">9 Holes</span>
                          </label>
                        )}
                    </div>


                  </div> */}
                  {props?.teeTimeData?.Hole > 0 && (
                    <div className="form-group">
                      <div className="col-sm-10 padding-0 padding-l10 margin-tb10">
                        <label className="inline">
                          <input
                            type="radio"
                            id="radio18"
                            className="radio18"
                            name="hole"
                            value={hole}
                            checked={true}
                            disabled
                          />
                          <span className="lbl">{hole} Holes</span>
                        </label>
                      </div>
                    </div>
                  )}

                  
                  <strong className="pull-right margin-tb1">
                    Available Carts: <span id="lblAvailableCart"></span>{" "}
                    <span id="lblAvailableCaddy">{cartAvailability}</span>
                  </strong>
                  {
                      props?.bookingOtherMembers?.length > 0 && (
                        <>
                        <div className="col-sm-10 padding-0 margin-tb5">
                        <strong className="">Co-Players</strong>
                        </div>
                      {/* old data */}
                      <table
                        id="table-user"
                        className="table table-bordered table-hover"
                      >
                        <thead className="thin-border-bottom">
                          <tr>
                            <th>Players</th>
                            <th>Category</th>
                            <th>Cart</th>
                          </tr>
                        </thead>
                        <tbody>
                        {props?.bookingOtherMembers?.length > 0 &&
                        props?.bookingOtherMembers?.map((m, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                {m.UserName}
                              {/* {!(m.IsValidMember === "Y" || m.UserType === "Guest" || m.UserType === "Player") && (
                                m.SubCategoryID === 7 && isWeekend === "Y" ? (
                                    <small className="text-coupon text-danger">Weekday Member</small>
                                  ) : (
                                    <small className="text-coupon text-danger">Subscription Expired!</small>
                                  )
                                )} */}
                                {/* {(m.isValidMember === 'Y' || m.type === 'Guest' || m.type === 'Player') ? null : (
                                      m.subCategoryID === 7 && isWeekend === 'Y' ? (
                                        <small className="text-coupon text-danger"> Weekday Member</small>
                                      ) : (
                                        <small className="text-coupon text-danger"> Subscription Expired!</small>
                                      )
                                    )} */}
                              </td>
                              <td>
                                {m.SubCategoryName}
                              </td>
                              <td>
                                <input
                                  className="user-cart"
                                  name="user-cart"
                                  type="checkbox"
                                  checked={m.IsCaddyRequired == 'Y'}
                                  disabled={true}
                                />
                                <span className="lbl"></span>
                              </td>
                            </tr>
                          );
                        })}
                        </tbody>
                      </table>
                      {/* old close */}
                        </>
                      )

                  }
                  {
                      props?.bookingMembers?.length > 0 && (
                        <>
                        <div className="col-sm-10 padding-0 margin-tb5">
                        <strong className="">Members</strong>
                        </div>
                      {/* old data */}
                      <table
                        id="table-user"
                        className="table table-bordered table-hover"
                      >
                        <thead className="thin-border-bottom">
                          <tr>
                            <th>Players</th>
                            <th>Category</th>
                            <th>Cart</th>
                          </tr>
                        </thead>
                        <tbody>
                        {props?.bookingMembers?.length > 0 &&
                        props?.bookingMembers?.map((m, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                {m.UserName}
                              {/* {!(m.IsValidMember === "Y" || m.UserType === "Guest" || m.UserType === "Player") && (
                                m.SubCategoryID === 7 && isWeekend === "Y" ? (
                                    <small className="text-coupon text-danger">Weekday Member</small>
                                  ) : (
                                    <small className="text-coupon text-danger">Subscription Expired!</small>
                                  )
                                )} */}
                                {/* {(m.isValidMember === 'Y' || m.type === 'Guest' || m.type === 'Player') ? null : (
                                      m.subCategoryID === 7 && isWeekend === 'Y' ? (
                                        <small className="text-coupon text-danger"> Weekday Member</small>
                                      ) : (
                                        <small className="text-coupon text-danger"> Subscription Expired!</small>
                                      )
                                    )} */}
                              </td>
                              <td>
                                {m.SubCategoryName}
                              </td>
                              <td>
                                <input
                                  className="user-cart"
                                  name="user-cart"
                                  type="checkbox"
                                  checked={m.IsCaddyRequired == 'Y'}
                                  disabled={true}
                                />
                                <span className="lbl"></span>
                              </td>
                            </tr>
                          );
                        })}
                        </tbody>
                      </table>
                      {/* old close */}
                        </>
                      )

                    }
                    
                  <hr className="divider" />
                  {rateDetails && (
                    <FeeSummary
                    rateDetails={rateDetails}
                    />
                  )}

                    {/* <table className="table table-bordered table-hover margin-b30">
                                                                                <thead className="light-grey-background">
                                                                                    <tr>
                                                                                        <th>Description</th>
                                                                                        <th className="text-right">Amount (₹)</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {rateDetails.GreenFee !== 0 && (
                                                                                        <tr>
                                                                                            <td>Green Fee</td>
                                                                                            <td className="text-right">₹ {rateDetails.GreenFee}</td>
                                                                                        </tr>
                                                                                    )}
                                                                                    {rateDetails.ShowCart && (
                                                                                        <tr>
                                                                                            <td>{rateDetails.NoOfCart} Cart</td>
                                                                                            <td className="text-right"> ₹ {rateDetails?.CartFee}</td>
                                                                                        </tr>
                                                                                    )}
                                                                                    {rateDetails.ShowCaddy && (
                                                                                        <tr>
                                                                                            <td>{rateDetails.NoOfCaddy} Caddy</td>
                                                                                            <td className="text-right"> ₹ {rateDetails?.CaddyFee}</td>
                                                                                        </tr>
                                                                                    )}
                                                                                    {rateDetails?.Discount != 0 && (
                                                                                        <tr>
                                                                                            <td>Discount</td>
                                                                                            <td className="text-right">- ₹ {rateDetails?.Discount}</td>
                                                                                        </tr>
                                                                                    )}
                                                                                    <tr>
                                                                                        <td>SGST (9%)</td>
                                                                                        <td className="text-right">₹ {rateDetails?.Sgst}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td>CGST (9%)</td>
                                                                                        <td className="text-right">₹ {rateDetails?.Cgst}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td><strong>Total</strong></td>
                                                                                        <td className="text-right"><strong>₹ {rateDetails.Total}</strong></td>
                                                                                    </tr>
                                                                                </tbody>
                    </table> */}
                  <div className="form-group">
                      <textarea
                      name="txtComment"
                      rows="2"
                      cols="20"
                      id="txtComment"
                      className="form-control"
                      placeholder="Comments"
                      value={comment || ""}
                      onChange={({ target }) => handleComment(target.value)}
                      disabled = {!props?.editValidation?.IsEdit}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                {/* <div className="col-sm-12 margin-b10">
                  <label className="inline">
                    <input
                      type="radio"
                      className="ace"
                      id="redioPaymentGateway"
                      name="payment"
                      checked={paymentMethod === "0"}
                      value="0"
                      onChange={handlePaymentMethodChange}
                    />
                    <span className="lbl">Payment Gateway</span>
                  </label>
                  <label className="inline margin-l10">
                    <input
                      type="radio"
                      className="ace"
                      id="redioCashCard"
                      name="payment"
                      checked={paymentMethod === "1"}
                      value="1"
                      onChange={handlePaymentMethodChange}
                    />
                    <span className="lbl">Cash Card</span>
                  </label>
                </div> */}
                <button
                  type="button"
                  id="btnModalClose"
                  className="btn btn-default btn-booking-close margin-r5"
                  onClick={onBookingModalClose}
                >
                  {" "}
                  Close{" "}
                </button>
                <button
                    type="button"
                    id="btnInvoice"
                    name="btnInvoice"
                    className="btn btn-info margin-r5"
                    onClick={()=>viewForm(props?.teeTimeData?.TransactionID)}
                  >
                    {" "}
                    Invoice{" "}
                  </button>
                {props?.editValidation?.IsCancel && (
                  <>
                  <button
                    type="button"
                    id="btnCancel"
                    name="btnCancel"
                    className="btn btn-danger margin-r5"
                    onClick={cancelBooking}
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                  <button
                          type="button"
                          id="btnUpdate"
                          name="btnUpdate"
                          className="btn btn-success"
                          onClick={updateBooking}
                        >
                          {" "}
                          Update{" "}
                  </button>
                  </>
                    )}

                {/* {props.action === "e" ? (
                  <>
                    {props?.editValidation?.IsCancel && (
                      <button
                        type="button"
                        id="btnCancel"
                        name="btnCancel"
                        className="btn btn-danger margin-r5"
                        onClick={cancelBooking}
                      >
                        {" "}
                        Cancel{" "}
                      </button>
                    )} */}

                    {/* {props?.editValidation?.IsEdit && (
                      <button
                        type="button"
                        id="btnUpdate"
                        name="btnUpdate"
                        className="btn btn-success"
                        onClick={postBooking}
                      >
                        {" "}
                        Update{" "}
                      </button>

                      <button
                        type="button"
                        id="btnSave"
                        name="btnSave"
                        className="btn btn-success"
                        onClick={postBooking}
                      >
                        Proceed To Pay{" "}
                        {rateDetails.finalAmount && (
                          <>
                            ₹&nbsp;{rateDetails.finalAmount}
                          </>
                        )}
                      </button>

                    )}
                  </>
                ) : (
                  <button
                    type="button"
                    id="btnSave"
                    name="btnSave"
                    className="btn btn-success"
                    onClick={postBooking}
                  >
                    {" "}
                    Proceed To Pay &#8377;&nbsp;{rateDetails.finalAmount}
                  </button>
                )} */}
                <p className="margin-b0 margin-t10">
                  By continuing you agree to our
                  <a href="/booking-terms" target="_blank">
                    {" "}
                    Booking Terms
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {addModal && (
          <AddMember
            show={addModal}
            from="#modalBook"
            SelectedDate={props.SelectedDate}
            isWeekend={isWeekend}
            // members={members}
            members={userList}
            setMembers={updateMembersAndCalculate}
            onDismissModal={() => setAddModal(false)}
            otherMembers={props.bookingMembers}
          />
        )}

        {addGuest && (
          <GuestModal
            show={addGuest}
            from="#modalBook"
            members={members}
            setMembers={updateMembersAndCalculate}
            onDismissModal={() => setAddGuest(false)}
          />
        )}
        {addSlot && (
          <Slot
            show={addSlot}
            date={moment(props.SelectedDate).format('YYYY-MM-DD')}
            from="#modalBook"
            members={members}
            setMembers={updateMembersAndCalculate}
            onDismissModal={() => setAddSlot(false)}
            oldSlot={slot}
            slot={newSlot}
            setSlot={setNewSlot}
            totalMembersCount={totalMembersCount}
            socketMaster={props.socketMaster}
          />
        )}
        {showGSTModal && (
          <AddGSTNumber
            setSelectCompany={setSelectedCompany}
            refID={refID}
            selectCompany={selectedCompany}
            onDismissModal={setShowGSTModal}
          />
        )}
      </>
    );
};

export default BookingModal;